import i18n from "i18next";
import { type FC, useCallback } from "react";

import { useReturnTo } from "../../core/router/navigation/returnTo";
import { SecondaryButton } from "../Buttons/components/ActionButton";

export type BackButtonProps = {
    isDisabled: boolean;
    url?: string;
    onBeforeNavigate?: () => void;
};

export const CancelButton: FC<BackButtonProps> = ({ isDisabled, url, onBeforeNavigate }) => {
    const navigateToReturn = useReturnTo(url ?? "/");

    const callback = useCallback(() => {
        if (!url) {
            return;
        }

        if (onBeforeNavigate) onBeforeNavigate();
        navigateToReturn();
    }, [navigateToReturn, onBeforeNavigate, url]);

    return (
        <SecondaryButton name="go_back" onClick={callback} disabled={isDisabled}>
            {i18n.t("button.cancel")}
        </SecondaryButton>
    );
};
